import React, { Component } from 'react'
import { Navbar } from './Navbar/Navbar'
import { Tooltip }  from './Tooltip/Tooltip'
import { Backdrop } from '../UI/Backdrop/Backdrop'
export default class Nav extends Component {

    state = {
        modal: false
    }

    TooltipHandler = () => {
        this.setState({modal: !this.state.modal})
    }

    render() {
        return (
            <div className="absolute  left-0 right-0">
            <Backdrop backdropHandler={this.TooltipHandler} isOpen={this.state.modal}/>
            <Navbar />
            <Tooltip tooltipHandler={this.TooltipHandler} modal={this.state.modal}/>
        </div>
        )
    }
}

